import QRCode from 'react-qr-code';
import styled from 'styled-components';
import { CountdownTimer } from './CntTimer';
import { useApiHook } from '../../hook/useApiHook';
import { useEffect, useState } from 'react';
import { TicketNumberType } from '../../store/infoStore';
import { getQrUrl } from '../../utils';
import { ImageUtils } from '../../utils/ImageUtils';

export const QrTicket = ({ cnt }: { cnt: TicketNumberType }) => {
  const [qr, setQr] = useState({
    qrHash: '',
    createDate: '',
  });
  const { getQr } = useApiHook();

  useEffect(() => {
    getQr(cnt.tnmtScheduleSrl).then(setQr);
  }, [getQr, cnt.tnmtScheduleSrl]);

  return (
    <Container>
      <Ticket src={ImageUtils.Card}></Ticket>
      <TicketTextContainer>
        <Title>오프라인 메인 이벤트 참가 정보</Title>
        <Inner>
          <LeftItem>
            <NumberTitleContainer>
              <NumberTitle>참가자 번호</NumberTitle>
            </NumberTitleContainer>
            <TicketText>{cnt.ticketNo}</TicketText>
          </LeftItem>

          <RightItem>
            <QrArea>
              <Qr value={getQrUrl(qr?.qrHash || '', cnt.tnmtScheduleSrl)}></Qr>
            </QrArea>
            {qr.createDate && (
              <ExpandTextContainer key={qr.createDate}>
                <ExpandText>
                  <CountdownTimer initialTime={qr.createDate} />
                  <UnderLine onClick={() => getQr(cnt.tnmtScheduleSrl).then(setQr)}>
                    유효시간 연장하기
                  </UnderLine>
                </ExpandText>
              </ExpandTextContainer>
            )}
          </RightItem>
        </Inner>
      </TicketTextContainer>
    </Container>
  );
};

const Ticket = styled.img`
  position: relative;
  width: 330px;
`;

const Title = styled.h3`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);

  font-size: 16px;
  line-height: 24px;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;

  padding-left: 40px;
  padding-right: 14px;
  margin-top: 0px;
`;

const LeftItem = styled.div`
  width: 357px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);

  margin-right: 12px;
`;

const RightItem = styled.div`
  flex: 1;
`;

const NumberTitleContainer = styled.div`
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  height: 29px;
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  font-size: 16px;
  line-height: 29px;
`;

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

const Qr = styled(QRCode)`
  position: relative;

  width: 95px;
  height: 90px;
`;

const QrArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  position: relative;

  width: 100px;
  height: 100px;
`;

const ExpandTextContainer = styled.div`
  position: absolute;
  width: 100%;

  bottom: -25px;
  right: 0;
  text-align: right;
  padding-right: 10px;
`;

const ExpandText = styled.h3`
  color: #ff0000;
  letter-spacing: -0.2px;
  font-family: 400;

  font-size: 14px;
`;

const UnderLine = styled.span`
  text-decoration: underline;
  margin-left: 3px;
`;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  color: #000000;
  text-align: center;

  font-size: 64px;
  line-height: 69px;
`;
